// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Button,
  Image,
  Message,
  Embed,
  Form,
  Label,
  Container,
  Segment,
  Grid,
  Placeholder
} from 'semantic-ui-react'
import transform from '../assets/transform.png'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import fire from '../config/Fire'

export default class Sheets extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      empty: true,
      sheets: []
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  video = (e) => {
    this.setState({
      video: true
    })
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.viewSheets()
      } else {
        this.props.history.push('/')
      }
    })
  }

  viewSheets = (e) => {
    this.setState({ loading: true })
    console.log('this.props.userUnderscore :', this.props.userUnderscore)
    fetch('https://murkstomstag.herokuapp.com/api/v1/view/sheets', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('json :', json)
        console.log(json.sheets)
        this.setState({ loading: false, empty: json.empty, sheets: json.sheets, video: false })
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  submitID = (e) => {
    var self = this
    e.preventDefault()
    self.setState({ loading: true })
    var url =
      'https://spreadsheets.google.com/feeds/list/' +
      self.state.sheetID +
      '/1' +
      '/public/values?alt=json'
    fetch(url)
      .then(function (response) {
        if (response.status === 200) {
          self.saveSheet()
        }
      })
      .catch(function (error) {
        console.log(error)
        self.setState({ error: 'Error: Invalid ID. Please try again.', loading: false })
      })
  }

  saveSheet = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/save/sheet', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        sheetID: this.state.sheetID
      })
    })
      .then((response) => {
        if (response.status === 200) {
          this.viewSheets()
        } else {
          this.setState({ error: 'Internal Server Error |  code 500', loading: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  shareSheet = (id, title) => {
    this.setState({ sharing: true, selectedIndex: id, activated: false, copied: null, error: null })
    fetch('https://murkstomstag.herokuapp.com/api/v1/share/sheet', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        title: title,
        id: id
      })
    }).then((response) => {
      if (response.status === 200) {
        this.setState({ sharing: false, activated: true, copied: true, copybtn: false })
      } else {
        this.setState({ error: 'Internal Server Error |  code 500', loading: false })
      }
    })
  }

  render () {
    let {
      loading,
      error,
      video,
      empty,
      copied,
      activated,
      copybtn,
      selectedIndex,
      saved,
      sharing
    } = this.state

    const sheets =
      !this.state.empty &&
      this.state.sheets.map((item, index) => (
        <div className='screen-card mb' key={index}>
          <Segment basic fluid>
            <Grid verticalAlign='middle' stackable>
              <Grid.Column width='5' floated='left'>
                <h3>{item.title}</h3>
              </Grid.Column>
              <Grid.Column width='5' floated='right'>
                <Button.Group>
                  <Button
                    compact
                    style={{ backgroundColor: '#E5E1DB', color: '#000' }}
                    href={'/manage/sheet/' + item.value}>
                    Edit
                  </Button>
                  <Button compact basic onClick={() => this.shareSheet(item.value, item.title)}>
                    Share
                  </Button>
                </Button.Group>
              </Grid.Column>
            </Grid>

            {selectedIndex === item.value ? (
              <div className='mts'>
                {activated && (
                  <div className='mbs'>
                    <h5 style={{ color: '#000' }}>
                      <b>Link sharing enabled successfully.</b>
                    </h5>
                  </div>
                )}
                {copied && (
                  <div>
                    <Message fluid style={{ overflow: 'hidden' }}>
                      <h6>
                        <a
                          style={{ color: '#000' }}
                          href={'https://murkstom.com/public/sheet/' + item.value}>
                          {'https://murkstom.com/public/sheet/' + item.value}
                        </a>
                      </h6>
                    </Message>
                    <CopyToClipboard
                      text={'https://murkstom.com/public/sheet/' + item.value}
                      onCopy={() => {
                        this.setState({
                          copybtn: true
                        })
                      }}>
                      <div>
                        <Label
                          size='large'
                          style={{ backgroundColor: '#F4D271' }}
                          className='cursor'>
                          Copy to clipboard
                        </Label>
                        {copybtn && <Label size='large'>Copied!</Label>}
                      </div>
                    </CopyToClipboard>
                  </div>
                )}
                {sharing && (
                  <Message fluid>
                    <h5>
                      <b>Loading...</b>
                    </h5>
                  </Message>
                )}
              </div>
            ) : null}
          </Segment>
        </div>
      ))

    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <Image
            centered
            style={{ width: '30px' }}
            src='https://seeklogo.com/images/G/google-sheets-logo-70C2B2CA6A-seeklogo.com.png'
          />
          <h2>Sheets</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='top' fluid={true}>
          <Grid.Column width='2' />
          <Grid.Column width='8'>
            {empty && !loading && (
              <Segment placeholder textAlign='left' style={{ backgroundColor: '#fff' }}>
                <h3>Such empty!</h3>
                {empty && !loading && (
                  <div className='mbs'>
                    <p>
                      First you must publish the sheet to the web using File -> Publish to the web
                      then enable Link sharing. Copy the ID from your Google spreadsheet page. It's
                      the big long aplha-numeric code in the middle of your document URL.
                    </p>
                    <h5>
                      For more information please visit the{' '}
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://murkstom.joliefaq.io/Spreadsheets/how-to-do-i-locate-a-google-spreadsheet-id'>
                        help center
                      </a>
                    </h5>
                  </div>
                )}
              </Segment>
            )}
            {loading ? (
              <Placeholder fluid>
                <Placeholder.Header image>
                  <Placeholder.Line length='medium' />
                  <Placeholder.Line length='short' />
                </Placeholder.Header>
                <Placeholder.Paragraph>
                  <Placeholder.Line length='long' />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                </Placeholder.Paragraph>
              </Placeholder>
            ) : (
              <div>{sheets}</div>
            )}
            {video && !saved && !loading ? (
              <Embed id='Z233jC1OBDI' placeholder={transform} source='youtube' />
            ) : null}
          </Grid.Column>
          <Grid.Column width='6'>
            <div className='screen-card'>
              <Segment fluid basic>
                <h3>Add new sheet</h3>

                <Form size='large'>
                  <Form.Input
                    negative={error}
                    focus
                    type='text'
                    placeholder='Enter your ID here'
                    onChange={this.handleChange}
                    name='sheetID'
                  />
                  <Form.Button
                    negative={error}
                    content='Submit'
                    loading={loading}
                    onClick={this.submitID}
                    color='black'
                    basic={!error}
                  />
                </Form>
                {error && (
                  <h5>
                    <b style={{ color: 'red' }}>{error}</b>
                  </h5>
                )}
                {!video && empty && !loading ? (
                  <div className='mts'>
                    <Button
                      style={{ backgroundColor: '#62A1DC', color: '#fff' }}
                      onClick={this.video}>
                      Watch tutorial
                    </Button>
                  </div>
                ) : null}
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='2' />
        </Grid>
      </Container>
    )
  }
}
